<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      title="参考分类"
      :visible.sync="visible"
      width="600px"
      center
      @close="handleClose"
      class="amazon_category_dialog"
    >
      <div>
        <span style="font-size: 14px;">产品名称：</span>
        <el-select
          v-model="value"
          remote
          filterable
          reserve-keyword
          placeholder="请输入核心关键词搜索"
          :remote-method="remoteMethod"
          :loading="loading"
          style="width: 300px;"
          size="small"
          @change="handleSelectCategory"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.categoryName"
            :value="item.categoryId"
          >
          </el-option>
        </el-select>
      </div>
      <div style="font-size: 14px;margin: 28px 0 20px 0;" v-if="categoryPath">参考分类：{{ categoryPath }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit" size="small"
          >关 闭</el-button
        >
        <el-button v-if="false" @click="handleClose" size="small"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getSkuList } from "@/api/template/template"
import { mapGetters } from "vuex"
import { getCategorySuggestion } from "@/api/order/lazada"

export default {
  name: "CategoryDialog",
  data() {
    return {
      tables: [],
      showPriceDialog: false,
      priceModify: "",
      priceType: "",
      isSet: false,
      skuList: [],

      options: [],
      value: [],
      list: [],
      loading: false,
      categoryPath: "",
    }
  },

  watch: {
    visible: {
      handler() {},
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["user", "dictMap", "dictData"]),
  },
  model: {
    prop: "visible",
    event: "change",
  },
  mounted() {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    shopId: {
      type: String,
      default: "",
    },
  },
  methods: {
    async remoteMethod(query) {
      if (query !== "") {
        this.loading = true
        let result = await getCategorySuggestion({
          shopId: this.shopId,
          productName: query,
        })

        this.loading = false
        this.options = result.data
      } else {
        this.options = []
      }
    },
    handleSubmit() {
      this.$emit("change", false)
      this.$emit("update", skuList)
    },
    handleClose() {
      this.$emit("change", false)
    },
    handleSelectCategory(categoryId) {
      for (let record of this.options) {
        if (categoryId == record.categoryId) {
          this.categoryPath = record.categoryPath
        }
      }
    },
  },
}
</script>

<style scoped>
.avator img {
  width: 119px;
}
.avator {
}
.info {
  margin-left: 4px;
}
.amazon_category_dialog ::v-deep .el-dialog__footer {
  text-align: right;
}
</style>
